import { InjectionToken } from '@angular/core';

export interface StreamData {
  id?: string;
  teamName?: string;
  carNumber?: string;
  carDeviceNumber?: string;
  eip?: string;
  eipAllocationId?: string;
  videoId?: string;
  rtmpStreamKey?: string;
  hlsPlaybackUrl?: string;
  hlsPromotionalVideoUrl?: string;
  isLive: boolean;
  class?: string;
  driverName?: string;
  streamingPartner?: string;
}

export const STREAM_DATA = new InjectionToken<StreamData[]>('STREAM_DATA');
export const MAIN_STREAM_DATA = new InjectionToken<StreamData>('MAIN_STREAM_DATA');
